import React from "react";
import { Realtime_BaseUrl, TenantID } from "../../Container/BaseUrl/BaseUrl";
import { StyledPaper } from "../../CustomComponent/TableCompoent";
import { CgMaximizeAlt } from "react-icons/cg";
import { styled } from "@mui/material/styles";

const IconWrapper = styled("div")({
  position: "absolute",
  top: 13, // Adjust for vertical positioning
  right: 22, // Align to the right side
  cursor: "pointer",
  zIndex: 1000, // Ensures it appears above the iframe
  color: "blue",
});

const RealTimeDash = () => {
  const agentData = JSON.parse(localStorage.getItem("tokenAgent") || "{}");
  const tenantID = localStorage.getItem("TenantId") || "";
  const agentId = agentData?.agent_id;

  return (
    <StyledPaper style={{ position: "relative" }}>
      <IconWrapper>
        <CgMaximizeAlt
          style={{
            color: "var(--icon-color, #00BCD4)", // Default light gray
            cursor: "pointer",
          }}
          size={20}
          onClick={() =>
            window.open(
              `${Realtime_BaseUrl}?tenantID=${tenantID}&agentId=${
                agentData.role === "Agent" ? agentId : ""}&groupId=${agentData.group_id && agentData.group_id.length == 1 ? agentData.group_id[0] :""}
              }`,
              "_blank"
            )
          }
        />
      </IconWrapper>
      <iframe
        src={`${Realtime_BaseUrl}?tenantID=${tenantID}&agentId=${
          agentData.role === "Agent" ? agentId : ""
        }&group_id=${agentData.group_id && agentData.group_id.length == 1 ? agentData.group_id[0] :""} `}
        title="Individual Agent Dashboard"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </StyledPaper>
  );
};

export default RealTimeDash;
